// extracted by mini-css-extract-plugin
export var pillWrapper = "_m4-0";
export var showOverflow = "_m4-1";